import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { mobileSessionDynamic } from "@ca-dmv-radv/data";

export default function SmartEdlSession({ applicationType }) {
  const params = useParams();

  useEffect(() => {
    (async () => {
      try {
        console.log(
          "Calling mobileSessionDynamic with token:",
          params.token,
          "applicationType:",
          applicationType
        );
        await mobileSessionDynamic(params.token, applicationType);
      } catch (error) {
        console.error("Caught error in SmartEdlSession:", error);
      }
    })();
  }, []);

  return null;
}
